import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        component: () => import('./pages/LoginPage.vue'),
    },
    {
        path: '/projects',
        component: () => import('./pages/ProjectsPage.vue'),
    },
    {
        path: '/projects/:id/files',
        component: () => import('./pages/DocumentFilesPage.vue'),
    },
    {
        path: '/auth/callback',
        component: () => import('./pages/AuthCallbackPage.vue'),
    },
    {
        path: '/profile',
        component: () => import('./pages/ProfilePage.vue'),
    },
    {
        path: '/legal/:slug',
        component: () => import('./pages/LegalDocumentPage.vue'),
    },
    {
        path: '/consents',
        component: () => import('./pages/UserConsentsPage.vue'),
    },
    {
        path: '/reconsent',
        component: () => import('./pages/ReconsentPage.vue'),
    },
    {
        path: '/reconsent-gate',
        component: () => import('./pages/ReconsentGatePage.vue'),
    },
    {
        path: '/blog',
        component: () => import('./pages/BlogPage.vue'),
    },
    {
        path: '/blog/:slug',
        component: () => import('./pages/BlogPostPage.vue'),
    },
    {
        path: '/',
        component: () => import('./pages/LandingPage.vue'),
    },
];

export default routes;